<template>
  <div id="app">
    
    <Header />

    
    <main class="main-content" :style="{ height: contentHeight + 'px' }">
      <keep-alive include="OnlineLearning,PracticeSystem">
        <router-view />
      </keep-alive>
    </main>

    
    <el-dialog :visible.sync="showInactivityDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false" width="420px" custom-class="inactivity-dialog" :modal="true" :modal-append-to-body="true">
      <div class="inactivity-dialog-content">
        <div class="icon-wrapper">
          <i class="el-icon-warning-outline"></i>
        </div>
        <div class="message-text">请继续学习</div>
        <div class="subtitle-text">检测到您已停留较长时间，请继续您的学习之旅</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="confirm-btn" @click="handleInactivityConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { addStudyDuration } from '@/api/common'

export default {
  name: "App",
  components: {
    Header
  },
  data() {
    return {
      studyDurationTimer: null, 
      studyDurationTimeout: null, 
      contentHeight: 0, 
      inactivityTimer: null, 
      inactivityTimeout: 30 * 1000, 
      isInactivityDialogShown: false, 
      showInactivityDialog: false, 
    };
  },
  mounted() {
    
    

    
    this.$bus.$on('user-login', this.startStudyDurationTimer);
    this.$bus.$on('user-logout', this.stopStudyDurationTimer);

    
    this.calculateContentHeight();

    
    window.addEventListener('resize', this.calculateContentHeight);

    
    this.startInactivityMonitoring();
  },
  beforeDestroy() {
    
    this.stopStudyDurationTimer();

    
    this.stopInactivityMonitoring();

    
    this.$bus.$off('user-login', this.startStudyDurationTimer);
    this.$bus.$off('user-logout', this.stopStudyDurationTimer);

    
    window.removeEventListener('resize', this.calculateContentHeight);
  },
  methods: {
    
    checkLoginAndStartTimer() {
      const isLoggedIn = localStorage.getItem('isLoggedIn');
      if (isLoggedIn === 'true') {
        this.startStudyDurationTimer();
      }
    },

    
    startStudyDurationTimer() {
      
      if (this.studyDurationTimer) {
        clearInterval(this.studyDurationTimer);
        this.studyDurationTimer = null;
      }
      
      if (this.studyDurationTimeout) {
        clearTimeout(this.studyDurationTimeout);
        this.studyDurationTimeout = null;
      }

      
      this.studyDurationTimeout = setTimeout(() => {
        
        this.submitStudyDuration();

        
        this.studyDurationTimer = setInterval(() => {
          this.submitStudyDuration();
        }, 5 * 60 * 1000);

        
        this.studyDurationTimeout = null;
      }, 5 * 60 * 1000); 
    },

    
    stopStudyDurationTimer() {
      if (this.studyDurationTimer) {
        clearInterval(this.studyDurationTimer);
        this.studyDurationTimer = null;
      }
      if (this.studyDurationTimeout) {
        clearTimeout(this.studyDurationTimeout);
        this.studyDurationTimeout = null;
      }
    },

    
    submitStudyDuration() {
      
      const isLoggedIn = localStorage.getItem('isLoggedIn');
      if (isLoggedIn !== 'true') {
        this.stopStudyDurationTimer();
        return;
      }

      
      addStudyDuration('5')
        .then((res) => {
          
        })
        .catch((error) => {
          
        });
    },

    
    calculateContentHeight() {
      const screenHeight = window.innerHeight;
      this.contentHeight = screenHeight - 300;
      
      
    },

    
    startInactivityMonitoring() {
      
      this.resetInactivityTimer();

      
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach(event => {
        document.addEventListener(event, this.resetInactivityTimer, true);
      });
    },

    
    stopInactivityMonitoring() {
      
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }

      
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach(event => {
        document.removeEventListener(event, this.resetInactivityTimer, true);
      });
    },

    
    resetInactivityTimer() {
      
      if (this.isInactivityDialogShown) {
        return;
      }

      
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }

      
      this.inactivityTimer = setTimeout(() => {
        this.openInactivityDialog();
      }, this.inactivityTimeout);
    },

    
    openInactivityDialog() {
      
      if (this.isInactivityDialogShown) {
        return;
      }

      this.isInactivityDialogShown = true;
      this.showInactivityDialog = true;
    },

    
    handleInactivityConfirm() {
      this.showInactivityDialog = false;
      this.isInactivityDialogShown = false;
      
      this.resetInactivityTimer();
    }
  }
};
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
  overflow: hidden;
}

#app {
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}


::v-deep {
  .el-dialog {
    border-radius: 30px;
    background: linear-gradient(#ffffff 15%, #e8edff 100%);
    box-shadow: none;
  }
}

.inactivity-dialog-content {
  text-align: center;
  padding: 10px 0;
}

.icon-wrapper {
  margin-bottom: 20px;
  animation: pulse 2s ease-in-out infinite;
}

.icon-wrapper i {
  font-size: 64px;
  color: #ff9800;
  display: inline-block;
}

.message-text {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.subtitle-text {
  font-size: 14px;
  color: #909399;
  line-height: 1.6;
}

.confirm-btn {
  width: 120px;
  height: 40px;
  font-size: 16px;
  border-radius: 20px;
  background: #2342C9 !important;
  border: none;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
}

.confirm-btn:active {
  transform: translateY(0);
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.9;
  }
}
</style>
